import React, { useEffect, useState } from "react";
import api, { formatError } from "@/lib/api";
import { toast } from "sonner";
import { Panel, DataTable, money, fmtDate } from "./shared";

const BUCKETS = ["current", "1-30", "31-60", "61-90", "90+"];
const BUCKET_LABEL = { current: "Not yet due", "1-30": "1–30 days", "31-60": "31–60 days", "61-90": "61–90 days", "90+": "90+ days" };

const ACCOUNT_COLS = [
  { key: "client_name", label: "Account" },
  { key: "invoices", label: "Invoices", right: true, render: (r) => r.invoices },
  ...BUCKETS.map((b) => ({ key: b, label: BUCKET_LABEL[b], right: true, render: (r) => (r[b] ? money(r[b]) : "—") })),
  { key: "total_outstanding", label: "Total due", right: true, render: (r) => <span className="text-sky-300">{money(r.total_outstanding)}</span> },
];

const INVOICE_COLS = [
  { key: "invoice_number", label: "Invoice #", mono: true },
  { key: "client_name", label: "Client" },
  { key: "due_date", label: "Due date", render: (r) => fmtDate(r.due_date) },
  { key: "days_overdue", label: "Days overdue", right: true, render: (r) => (
    <span className={r.days_overdue > 60 ? "text-rose-300" : r.days_overdue > 0 ? "text-amber-300" : "text-slate-400"}>{r.days_overdue}</span>) },
  { key: "aging_bucket", label: "Aging", render: (r) => BUCKET_LABEL[r.aging_bucket] },
  { key: "outstanding", label: "Outstanding", right: true, render: (r) => money(r.outstanding) },
];

export default function ReceivablesTab() {
  const [data, setData] = useState({ total_outstanding: 0, accounts: [], invoices: [] });
  useEffect(() => {
    api.get("/finance/receivables").then((r) => setData(r.data)).catch((e) => toast.error(formatError(e)));
  }, []);

  return (
    <div className="space-y-6">
      <Panel title="Dues / Receivables" subtitle="Outstanding balances owed by clients, aged from each invoice's due date."
             right={<div className="text-right"><div className="text-[10px] uppercase tracking-widest text-slate-500">Total outstanding</div>
               <div data-testid="receivables-total" className="font-mono-ops text-2xl text-sky-300">{money(data.total_outstanding)}</div></div>}>
        <DataTable testid="aging-table" columns={ACCOUNT_COLS} rows={data.accounts} empty="No outstanding balances." />
      </Panel>
      <Panel title="Open invoices" subtitle="Most overdue first.">
        <DataTable testid="open-invoices-table" columns={INVOICE_COLS} rows={data.invoices} empty="Nothing outstanding." />
      </Panel>
    </div>
  );
}
